import qrCode from '#frontend/util/qrCode.js';

import template from './qrCode.html' with { type: 'html' };

export default {
	name: 'CQrCode',
	props: {
		order: {
			type: Object,
			default: () => null
		},
		payment: {
			type: Object,
			default: () => null
		}
	},
	data() {
		return {
			showQrCode: false
		};
	},
	mounted() {
		try {
			const qrCodeCanvas = this.$refs.qrCode;
			const swiftCode = this.payment.offlinePayment.swiftCode.replace(/ +/g, ''); // Remove spaces
			qrCode(qrCodeCanvas, {
				amount: this.order.price.total.unformatted,
				currency: this.order.currency,
				iban: this.payment.offlinePayment.iban,
				message: this.payment.offlinePayment.referenceNumber,
				swiftCode
			});
			this.showQrCode = true;
		} catch {
			this.showQrCode = false;
		}
		this.$emit('show-qr-code', this.showQrCode);
	},
	template
};
